import { ActionTree, GetterTree, MutationTree } from "vuex";
import { IRootState } from "@iloq/shared";
import config from "@/config";
import { IProductGroup } from "@iloq/shared/IPartnerInfo";

export interface IOrderingPermissionState {
  restrictedFamilies: string[];
  orderableFamilies: string[];
}

const initialState: IOrderingPermissionState = {
  restrictedFamilies: config.get("restrictedProductFamilies"),
  orderableFamilies: [],
};

const actions: ActionTree<IOrderingPermissionState, IRootState> = {
  setOrderingPermissions({ commit }, productGroups: IProductGroup[]): void {
    commit("setOrderingPermissions", productGroups);
  },
};

const mutations: MutationTree<IOrderingPermissionState> = {
  setOrderingPermissions(state: IOrderingPermissionState, productGroups: IProductGroup[]): void {
    state.orderableFamilies = productGroups.reduce((prev: string[], group) => {
      prev.push(...group.itemCategories);
      return prev;
    }, []);
  },
};

const getters: GetterTree<IOrderingPermissionState, IRootState> = {
  isOrderingAllowed:
    (state) =>
    (family: string | null | undefined): boolean => {
      if (!family) {
        return true;
      }
      return !state.restrictedFamilies.includes(family) || state.orderableFamilies.includes(family);
    },
};

export const orderingPermissionModule = {
  actions,
  mutations,
  getters,
  state: initialState,
  namespaced: true,
};
